/* React Higher Order Component which fetches site maintenance mode status
    Child (WrappedComponent) will only render once meta tag data is successfully fetched.
    child will receive props: {
        maintenanceMode:  PropTypes.bool,
    }

*/

import React from 'react';
import PropTypes from 'prop-types';
const uuid = require('uuid');

const Globals = require('../../../../app/globals');
const SiteConfigActions = require('../../actions/SiteConfigActions');
const SiteConfigStore = require('../../stores/SiteConfigStore');

import LoadingMainContent from '../loading/LoadingMainContent';
import ErrorBox from '../common/ErrorBox';
import MaintenanceWarning from '../common/MaintenanceWarning';
const ReactUtil = require('../../util/ReactUtil');

const propTypes = {
    renderBeforeLoding: PropTypes.bool,
    showLoadingSpinner: PropTypes.bool,
    forceRefresh: PropTypes.bool,
    renderWarningDuringMaintenence: PropTypes.bool,
};

const defaultProps = {
    renderBeforeLoding: false,
    showLoadingSpinner: false,
    forceRefresh: false,
    renderWarningDuringMaintenence: false,
};

export default function withSiteMaintenanceMode(WrappedComponent) {
    class WithSiteMaintenanceMode extends React.Component {
        constructor(props) {
            super(props);

            const siteConfigStoreState = SiteConfigStore.getState();

            this.state = {
                loaded: false,
                getActionId: null,
                fatalError: null,
                maintenanceMode: siteConfigStoreState.maintenanceMode,
            };

            this.getMaintenanceMode = this.getMaintenanceMode.bind(this);
            this.unsubscribes = [
                SiteConfigStore.listen(this.onSiteConfigStoreChange.bind(this)),
            ];
        }

        UNSAFE_componentWillMount() {
            this.getMaintenanceMode();
        }

        componentWillUnmount() {
            this.unsubscribes.forEach(u => u());
        }

        getMaintenanceMode() {
            const actionId = uuid.v4();
            this.setState({ getActionId: actionId }, () => {
                SiteConfigActions.getMaintenanceMode(actionId);
            });
        }

        onSiteConfigStoreChange(newState) {
            if (newState.action.id === this.state.getActionId) {
                let updatedState;
                if (!!newState.action.error) {
                    updatedState = { loaded: true, getActionId: null, fatalError: newState.action.error };
                }
                else {
                    updatedState = { loaded: true, getActionId: null, maintenanceMode: newState.maintenanceMode };
                }

                this.setState(updatedState);
            }
        }

        render() {
            if (this.state.fatalError) {
                return <ErrorBox error={this.state.fatalError} />;
            }

            if (
                !this.state.loaded
                && !this.props.renderBeforeLoding
            ) {

                if (this.props.showLoadingSpinner) {
                    return (
                        <div className="assignment-instructor">
                            <LoadingMainContent />
                        </div>
                    );
                }
                else {
                    return null;
                }
            }

            if (
                this.state.loaded
                && this.state.maintenanceMode
                && this.props.renderWarningDuringMaintenence
            ) {
                return <MaintenanceWarning />;
            }

            return (
                <WrappedComponent
                    {...this.props}
                    maintenanceMode={this.state.maintenanceMode}
                />
            );
        }
    }

    WithSiteMaintenanceMode.propTypes = propTypes;
    WithSiteMaintenanceMode.defaultProps = defaultProps;
    WithSiteMaintenanceMode.displayName = `WithSiteMaintenanceMode(${ReactUtil.getComponentDisplayName(WrappedComponent)})`;
    return WithSiteMaintenanceMode;
}